export default __webpack_public_path__ + "static/media/upload.f9a2063f.svg";